const EMAIL_REGEXP = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Check if the email is valid
 * @param email - The email to check
 * @returns true if the email is valid, false otherwise
 */
export const isValidEmail = (email: string) => EMAIL_REGEXP.test(email);

export const LIST_SEPARATOR_REGEXP = /[,\s\t\n]+/;

/**
 * Parse emails from bulk input text with multiple separator support
 * Supports comma, space, tab, and newline separators
 * @param {string} text - The text containing emails
 * @returns {string[]} Array of valid email addresses
 */
export const parseBulkEmails = (text: string) => {
  return text
    .split(LIST_SEPARATOR_REGEXP) // Split by comma, space, tab, or newline
    .map(email => email.trim())
    .filter(email => email.length > 0 && isValidEmail(email));
};
